import { __decorate } from "tslib";
import { field } from '@simonbackx/simple-encoding';
import { TinyMember } from './Member.js';
import { Registration } from './Registration.js';
export class RegistrationWithTinyMember extends Registration {
    static from(registration, member) {
        return RegistrationWithTinyMember.create({
            ...registration,
            member,
        });
    }
}
__decorate([
    field({ decoder: TinyMember })
], RegistrationWithTinyMember.prototype, "member", void 0);
//# sourceMappingURL=RegistrationWithTinyMember.js.map